import { Controller } from "stimulus"

// Connects to data-controller="thread-model"
// Handles model select button changes when user loads thread history
export default class extends Controller {
  static targets = ["modelName", "modelButton"]

  connect() {
  }

  get isWhitelabel() {
    return document.body.dataset.whitelabel === "true"
  }

  setModelName(event) {
    const modelName = event.currentTarget.dataset.modelName

    // Find and update the model name display directly
    const modelNameElement = document.querySelector('[data-thread-model-target="modelName"]')
    const modelButtonElement = document.querySelector('[data-thread-model-target="modelButton"]')

    if (modelNameElement && !this.isWhitelabel) {
      modelNameElement.textContent = modelName
    }

    if (modelButtonElement && !this.isWhitelabel) {
      modelButtonElement.classList.add("disabled")
      modelButtonElement.setAttribute("title", "Start a new chat to change models")
      modelButtonElement.addEventListener(
        "click",
        (e) => {
          e.preventDefault()
          e.stopImmediatePropagation()
        },
        true
      )
    }
  }

  updateModelName(modelName) {
    if (this.hasModelNameTarget && !this.isWhitelabel) {
      this.modelNameTarget.textContent = modelName
    }

    if (this.hasModelButtonTarget && !this.isWhitelabel) {
      this.modelButtonTarget.classList.add("disabled")
      this.modelButtonTarget.setAttribute("title", "Start a new chat to change models")
      this.modelButtonTarget.addEventListener(
        "click",
        (e) => {
          e.preventDefault()
          e.stopImmediatePropagation()
        },
        true
      )
    }
  }
}